// extracted by css-extract-rspack-plugin
export default {"status":"_ac736bb3","contact":"_daf08947","top":"_7e47bd0c"};